// Auto-generated index of all C++ components

import CPP from "./CPP.jsx";
import CPP_Home from "./CPP_Home.jsx";
import CPP_Intro from "./CPP_Intro.jsx";
import CPP_Get_Started from "./CPP_Get_Started.jsx";
import CPP_Syntax from "./CPP_Syntax.jsx";
import Statements from "./Statements.jsx";
import CPP_Output from "./CPP_Output.jsx";
import Print_Numbers from "./Print_Numbers.jsx";
import New_Lines from "./New_Lines.jsx";
import CPP_Comments from "./CPP_Comments.jsx";
import CPP_Variables from "./CPP_Variables.jsx";
import Multiple_Variables from "./Multiple_Variables.jsx";
import Identifiers from "./Identifiers.jsx";
import Constants from "./Constants.jsx";
import Variables_Examples from "./Variables_Examples.jsx";
import CPP_User_Input from "./CPP_User_Input.jsx";
import CPP_Data_Types from "./CPP_Data_Types.jsx";
import Data_Types from "./Data_Types.jsx";
import Numeric_Data_Types from "./Numeric_Data_Types.jsx";
import Boolean_Data_Types from "./Boolean_Data_Types.jsx";
import Character_Types from "./Character_Types.jsx";
import String_Types from "./String_Types.jsx";
import The_auto_Keyword from "./The_auto_Keyword.jsx";
import CPP_Operators from "./CPP_Operators.jsx";
import Arithmetic from "./Arithmetic.jsx";
import Assignment from "./Assignment.jsx";
import Comparison from "./Comparison.jsx";
import Logical from "./Logical.jsx";
import CPP_Strings from "./CPP_Strings.jsx";
import Concatenation from "./Concatenation.jsx";
import Numbers_and_Strings from "./Numbers_and_Strings.jsx";
import String_Length from "./String_Length.jsx";
import Access_Strings from "./Access_Strings.jsx";
import Special_Characters from "./Special_Characters.jsx";
import User_Input_Strings from "./User_Input_Strings.jsx";
import Omitting_Namespace from "./Omitting_Namespace.jsx";
import C_Style_Strings from "./C_Style_Strings.jsx";
import CPP_Math from "./CPP_Math.jsx";
import CPP_Booleans from "./CPP_Booleans.jsx";
import Boolean_Expression from "./Boolean_Expression.jsx";
import CPP_If from "./CPP_If.jsx";
import Else from "./Else.jsx";
import Else_If from "./Else_If.jsx";
import Ternary_Operator from "./Ternary_Operator.jsx";
import CPP_Switch from "./CPP_Switch.jsx";
import CPP_While_Loop from "./CPP_While_Loop.jsx";
import Do_While_Loop from "./Do_While_Loop.jsx";
import While_Real_Life_Example from "./While_Real_Life_Example.jsx";
import CPP_For_Loop from "./CPP_For_Loop.jsx";
import Nested_Loops from "./Nested_Loops.jsx";
import Foreach_Loop from "./Foreach_Loop.jsx";
import For_Real_Life_Example from "./For_Real_Life_Example.jsx";
import CPP_Break_Continue from "./CPP_Break_Continue.jsx";
import CPP_Arrays from "./CPP_Arrays.jsx";
import Arrays_and_Loops from "./Arrays_and_Loops.jsx";
import Omit_Array_Size from "./Omit_Array_Size.jsx";
import Size_of_an_Array from "./Size_of_an_Array.jsx";
import Arrays_Real_Life_Examples from "./Arrays_Real_Life_Examples.jsx";
import Multi_Dimensional_Arrays from "./Multi_Dimensional_Arrays.jsx";
import CPP_Structures from "./CPP_Structures.jsx";
import CPP_Enums from "./CPP_Enums.jsx";
import CPP_References from "./CPP_References.jsx";
import Memory_Address from "./Memory_Address.jsx";
import CPP_Pointers from "./CPP_Pointers.jsx";
import Dereference from "./Dereference.jsx";
import Modify_Pointers from "./Modify_Pointers.jsx";
import CPP_Memory_Management from "./CPP_Memory_Management.jsx";
import Memory_Management from "./Memory_Management.jsx";
import New_and_Delete from "./New_and_Delete.jsx";
import CPP_Functions from "./CPP_Functions.jsx";
import CPP_Function_Parameters from "./CPP_Function_Parameters.jsx";
import Default_Parameters from "./Default_Parameters.jsx";
import Multiple_Parameters from "./Multiple_Parameters.jsx";
import Return_Values from "./Return_Values.jsx";
import Pass_By_Reference from "./Pass_By_Reference.jsx";
import Pass_Arrays from "./Pass_Arrays.jsx";
import Structure_to_Function from "./Structure_to_Function.jsx";
import Function_Real_Life_Example from "./Function_Real_Life_Example.jsx";
import CPP_Function_Overloading from "./CPP_Function_Overloading.jsx";
import CPP_Scope from "./CPP_Scope.jsx";
import CPP_Recursion from "./CPP_Recursion.jsx";
import CPP_Lambda from "./CPP_Lambda.jsx";
import CPP_OOP from "./CPP_OOP.jsx";
import CPP_Classes_Objects from "./CPP_Classes_Objects.jsx";
import CPP_Class_Methods from "./CPP_Class_Methods.jsx";
import CPP_Constructors from "./CPP_Constructors.jsx";
import Constructor_Overloading from "./Constructor_Overloading.jsx";
import CPP_Access_Specifiers from "./CPP_Access_Specifiers.jsx";
import CPP_Encapsulation from "./CPP_Encapsulation.jsx";
import CPP_Friend_Functions from "./CPP_Friend_Functions.jsx";
import CPP_Inheritance from "./CPP_Inheritance.jsx";
import Multilevel_Inheritance from "./Multilevel_Inheritance.jsx";
import Multiple_Inheritance from "./Multiple_Inheritance.jsx";
import Access_Specifiers from "./Access_Specifiers.jsx";
import CPP_Polymorphism from "./CPP_Polymorphism.jsx";
import Virtual_Functions from "./Virtual_Functions.jsx";
import CPP_Templates from "./CPP_Templates.jsx";
import CPP_Files from "./CPP_Files.jsx";
import CPP_Date from "./CPP_Date.jsx";
import CPP_Errors from "./CPP_Errors.jsx";
import CPP_Debugging from "./CPP_Debugging.jsx";
import CPP_Exceptions from "./CPP_Exceptions.jsx";
import CPP_Input_Validation from "./CPP_Input_Validation.jsx";
import CPP_STL from "./CPP_STL.jsx";
import CPP_Vectors from "./CPP_Vectors.jsx";
import CPP_List from "./CPP_List.jsx";
import CPP_Stacks from "./CPP_Stacks.jsx";
import CPP_Queues from "./CPP_Queues.jsx";
import CPP_Deque from "./CPP_Deque.jsx";
import CPP_Sets from "./CPP_Sets.jsx";
import CPP_Maps from "./CPP_Maps.jsx";
import CPP_Iterators from "./CPP_Iterators.jsx";
import CPP_Algorithms from "./CPP_Algorithms.jsx";
import CPP_Namespaces from "./CPP_Namespaces.jsx";
import CPP_Projects from "./CPP_Projects.jsx";
import CPP_Add_Two_Numbers from "./CPP_Add_Two_Numbers.jsx";
import CPP_Random_Numbers from "./CPP_Random_Numbers.jsx";
import CPP_Reference from "./CPP_Reference.jsx";
import CPP_Keywords from "./CPP_Keywords.jsx";
import CPP_Iostream from "./CPP_Iostream.jsx";
import CPP_Fstream from "./CPP_Fstream.jsx";
import CPP_Cmath from "./CPP_Cmath.jsx";
import CPP_String from "./CPP_String.jsx";
import CPP_Cstring from "./CPP_Cstring.jsx";
import CPP_Ctime from "./CPP_Ctime.jsx";
import CPP_Vector from "./CPP_Vector.jsx";
import CPP_Algorithm from "./CPP_Algorithm.jsx";
import CPP_Examples from "./CPP_Examples.jsx";
import CPP_Real_Life_Examples from "./CPP_Real_Life_Examples.jsx";
import CPP_Compiler from "./CPP_Compiler.jsx";
import CPP_Exercises from "./CPP_Exercises.jsx";
import CPP_Quiz from "./CPP_Quiz.jsx";
import CPP_Syllabus from "./CPP_Syllabus.jsx";
import CPP_Study_Plan from "./CPP_Study_Plan.jsx";
import CPP_Certificate from "./CPP_Certificate.jsx";

const cppComponentsMap = {
  "<CPP />": CPP,
  "<CPP_Home />": CPP_Home,
  "<CPP_Intro />": CPP_Intro,
  "<CPP_Get_Started />": CPP_Get_Started,
  "<CPP_Syntax />": CPP_Syntax,
  "<Statements />": Statements,
  "<CPP_Output />": CPP_Output,
  "<Print_Numbers />": Print_Numbers,
  "<New_Lines />": New_Lines,
  "<CPP_Comments />": CPP_Comments,
  "<CPP_Variables />": CPP_Variables,
  "<Multiple_Variables />": Multiple_Variables,
  "<Identifiers />": Identifiers,
  "<Constants />": Constants,
  "<Variables_Examples />": Variables_Examples,
  "<CPP_User_Input />": CPP_User_Input,
  "<CPP_Data_Types />": CPP_Data_Types,
  "<Data_Types />": Data_Types,
  "<Numeric_Data_Types />": Numeric_Data_Types,
  "<Boolean_Data_Types />": Boolean_Data_Types,
  "<Character_Types />": Character_Types,
  "<String_Types />": String_Types,
  "<The_auto_Keyword />": The_auto_Keyword,
  "<CPP_Operators />": CPP_Operators,
  "<Arithmetic />": Arithmetic,
  "<Assignment />": Assignment,
  "<Comparison />": Comparison,
  "<Logical />": Logical,
  "<CPP_Strings />": CPP_Strings,
  "<Concatenation />": Concatenation,
  "<Numbers_and_Strings />": Numbers_and_Strings,
  "<String_Length />": String_Length,
  "<Access_Strings />": Access_Strings,
  "<Special_Characters />": Special_Characters,
  "<User_Input_Strings />": User_Input_Strings,
  "<Omitting_Namespace />": Omitting_Namespace,
  "<C_Style_Strings />": C_Style_Strings,
  "<CPP_Math />": CPP_Math,
  "<CPP_Booleans />": CPP_Booleans,
  "<Boolean_Expression />": Boolean_Expression,
  "<CPP_If />": CPP_If,
  "<Else />": Else,
  "<Else_If />": Else_If,
  "<Ternary_Operator />": Ternary_Operator,
  "<CPP_Switch />": CPP_Switch,
  "<CPP_While_Loop />": CPP_While_Loop,
  "<Do_While_Loop />": Do_While_Loop,
  "<While_Real_Life_Example />": While_Real_Life_Example,
  "<CPP_For_Loop />": CPP_For_Loop,
  "<Nested_Loops />": Nested_Loops,
  "<Foreach_Loop />": Foreach_Loop,
  "<For_Real_Life_Example />": For_Real_Life_Example,
  "<CPP_Break_Continue />": CPP_Break_Continue,
  "<CPP_Arrays />": CPP_Arrays,
  "<Arrays_and_Loops />": Arrays_and_Loops,
  "<Omit_Array_Size />": Omit_Array_Size,
  "<Size_of_an_Array />": Size_of_an_Array,
  "<Arrays_Real_Life_Examples />": Arrays_Real_Life_Examples,
  "<Multi_Dimensional_Arrays />": Multi_Dimensional_Arrays,
  "<CPP_Structures />": CPP_Structures,
  "<CPP_Enums />": CPP_Enums,
  "<CPP_References />": CPP_References,
  "<Memory_Address />": Memory_Address,
  "<CPP_Pointers />": CPP_Pointers,
  "<Dereference />": Dereference,
  "<Modify_Pointers />": Modify_Pointers,
  "<CPP_Memory_Management />": CPP_Memory_Management,
  "<Memory_Management />": Memory_Management,
  "<New_and_Delete />": New_and_Delete,
  "<CPP_Functions />": CPP_Functions,
  "<CPP_Function_Parameters />": CPP_Function_Parameters,
  "<Default_Parameters />": Default_Parameters,
  "<Multiple_Parameters />": Multiple_Parameters,
  "<Return_Values />": Return_Values,
  "<Pass_By_Reference />": Pass_By_Reference,
  "<Pass_Arrays />": Pass_Arrays,
  "<Structure_to_Function />": Structure_to_Function,
  "<Function_Real_Life_Example />": Function_Real_Life_Example,
  "<CPP_Function_Overloading />": CPP_Function_Overloading,
  "<CPP_Scope />": CPP_Scope,
  "<CPP_Recursion />": CPP_Recursion,
  "<CPP_Lambda />": CPP_Lambda,
  "<CPP_OOP />": CPP_OOP,
  "<CPP_Classes_Objects />": CPP_Classes_Objects,
  "<CPP_Class_Methods />": CPP_Class_Methods,
  "<CPP_Constructors />": CPP_Constructors,
  "<Constructor_Overloading />": Constructor_Overloading,
  "<CPP_Access_Specifiers />": CPP_Access_Specifiers,
  "<CPP_Encapsulation />": CPP_Encapsulation,
  "<CPP_Friend_Functions />": CPP_Friend_Functions,
  "<CPP_Inheritance />": CPP_Inheritance,
  "<Multilevel_Inheritance />": Multilevel_Inheritance,
  "<Multiple_Inheritance />": Multiple_Inheritance,
  "<Access_Specifiers />": Access_Specifiers,
  "<CPP_Polymorphism />": CPP_Polymorphism,
  "<Virtual_Functions />": Virtual_Functions,
  "<CPP_Templates />": CPP_Templates,
  "<CPP_Files />": CPP_Files,
  "<CPP_Date />": CPP_Date,
  "<CPP_Errors />": CPP_Errors,
  "<CPP_Debugging />": CPP_Debugging,
  "<CPP_Exceptions />": CPP_Exceptions,
  "<CPP_Input_Validation />": CPP_Input_Validation,
  "<CPP_STL />": CPP_STL,
  "<CPP_Vectors />": CPP_Vectors,
  "<CPP_List />": CPP_List,
  "<CPP_Stacks />": CPP_Stacks,
  "<CPP_Queues />": CPP_Queues,
  "<CPP_Deque />": CPP_Deque,
  "<CPP_Sets />": CPP_Sets,
  "<CPP_Maps />": CPP_Maps,
  "<CPP_Iterators />": CPP_Iterators,
  "<CPP_Algorithms />": CPP_Algorithms,
  "<CPP_Namespaces />": CPP_Namespaces,
  "<CPP_Projects />": CPP_Projects,
  "<CPP_Add_Two_Numbers />": CPP_Add_Two_Numbers,
  "<CPP_Random_Numbers />": CPP_Random_Numbers,
  "<CPP_Reference />": CPP_Reference,
  "<CPP_Keywords />": CPP_Keywords,
  "<CPP_Iostream />": CPP_Iostream,
  "<CPP_Fstream />": CPP_Fstream,
  "<CPP_Cmath />": CPP_Cmath,
  "<CPP_String />": CPP_String,
  "<CPP_Cstring />": CPP_Cstring,
  "<CPP_Ctime />": CPP_Ctime,
  "<CPP_Vector />": CPP_Vector,
  "<CPP_Algorithm />": CPP_Algorithm,
  "<CPP_Examples />": CPP_Examples,
  "<CPP_Real_Life_Examples />": CPP_Real_Life_Examples,
  "<CPP_Compiler />": CPP_Compiler,
  "<CPP_Exercises />": CPP_Exercises,
  "<CPP_Quiz />": CPP_Quiz,
  "<CPP_Syllabus />": CPP_Syllabus,
  "<CPP_Study_Plan />": CPP_Study_Plan,
  "<CPP_Certificate />": CPP_Certificate,
};

export default cppComponentsMap;
